const { getDateInstance } = require('./getDateInstance')

/**
 * Visszaadja, hogy a megadott dátum két másik dátum közé esik-e.
 * @param {string | number | Date} date - A dátum.
 * @param {string | number | Date} startDate - A kezdődátum.
 * @param {string | number | Date} endDate - A végdátum.
 * @returns {boolean} Beleesik a két dátum közé?
 */
module.exports.isDateBetween = function isDateBetween (date, startDate, endDate) {
  const d = getDateInstance(date).getTime()
  const start = getDateInstance(startDate).getTime()
  const end = getDateInstance(endDate).getTime()

  const min = Math.min(start, end)
  const max = Math.max(start, end)

  const isBetween = d >= min && d <= max

  return isBetween
}
